import React from "react";
import qs from "qs";
import { connect } from "react-redux";
import { addPayment } from "services/payment";
import { setAuthHeader } from "utils/setAuthHeader";
import { Header, Icon } from "semantic-ui-react";
import MainButton from "components/Buttons/MainButton";

const styles = {
	centered: {
		height: "100vh",
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
	},
};

const SumUpCallback = ({ location, history, addPayment, user }) => {
	//Set the bearer token
	const token = user.session.token;
	setAuthHeader(token, 'both');

	const parsedResult = qs.parse(location.search, { ignoreQueryPrefix: true });
	const path = location.pathname.split("/");
	const folderCode = path[path.length - 1];
	const price = path[path.length - 2];
	const folderId = path[path.length - 3];
	const success = parsedResult["smp-status"] === "success";
	addPayment("sumup", folderId, parsedResult["smp-tx-code"], parseFloat(price), success, null, null);
	return (
		<div style={styles.centered}>
			<Header as="h2" icon>
				{success && (
					<>
						<Icon name="check" color="green" circular inverted />
						Paiement réussi
					</>
				)}
				{!success && (
					<>
						<Icon name="close" color="red" circular inverted />
						Le paiement a échoué
					</>
				)}
				<Header.Subheader>
					{success && <div>Vous pouvez retourner au dossier</div>}
					{!success && <div>Retourner au dossier et relancer un paiement</div>}

					<MainButton onClick={() => history.push(`/home/foldermanager/${folderCode}`)} style={{ marginTop: 5 }}>
						Retourner au dossier
					</MainButton>
				</Header.Subheader>
			</Header>
		</div>
	);
};

const mapStateToProps = (state) => {
	return {
		user: state.user,
	};
};

const mapDispatchToProps = {
	addPayment,
};

export default connect(mapStateToProps, mapDispatchToProps)(SumUpCallback);
